import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { AboutSection } from '../components/AboutSection';
import { VenueSection } from '../components/VenueSection';
import { EventsSection } from '../components/EventsSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1039">
      <Header data-id="element-1040" />
      <main data-id="element-1041">
        <Hero data-id="element-1042" />
        <AboutSection data-id="element-1043" />
        <VenueSection data-id="element-1044" />
        <EventsSection data-id="element-1045" />
      </main>
      <Footer data-id="element-1046" />
    </div>;
}